import ButtonIcon from "@mui/icons-material/Add"
import { Button } from "@mui/material"
import React, { useState } from "react"
import { ButtonProps, useNotify, useRecordContext, useRefresh } from "react-admin"

import { auth0HttpClient } from "App/providers/auth0-client"
import appConfig from "config/app.config"

export const AddBillButton: React.FC<ButtonProps> = (props) => {
  const record = useRecordContext(props)
  const notify = useNotify()
  const refresh = useRefresh()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const createRequestedBill = async () => {
    if (!record?.id || isSubmitting) {
      return
    }

    setIsSubmitting(true)
    try {
      const { json } = await auth0HttpClient(
        `${appConfig.apiBaseUrl}/v1/reservations/draft-bills/selected`,
        {
          method: "POST",
          body: JSON.stringify({ reservation_ids: [record.id], intent: "requested" }),
        },
      )

      if (json.emitted === 0) {
        const reason = json.skipped_reservations?.[0]?.reason
        notify(reason ? `No bill created — ${reason.replace(/_/g, " ")}` : "No bill created", {
          type: "warning",
        })
        return
      }

      notify("Draft bill requested", { type: "info" })
      refresh()
    } catch (error) {
      notify(error instanceof Error ? error.message : "Failed to request bill", { type: "warning" })
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Button color="primary" onClick={createRequestedBill} disabled={isSubmitting || !record?.id}>
      <ButtonIcon /> Create New Bill
    </Button>
  )
}
